export enum EditName {
  GENERAL_SETTINGS = "generalSettings",
}
